"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KebabMenu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _button = require("../button");
var _menu = require("../menu");
var _kebabMenuTheme = require("./kebabMenuTheme");
const KebabMenu = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    size = "medium",
    menuProps: {
      onOpenRequested: providedOnOpenRequested,
      ...restMenuProps
    } = {},
    ...rest
  } = _ref;
  const {
    isOpen,
    onCloseRequested,
    onOpenRequested
  } = (0, _menu.useMenuOpenState)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    getTargetHTMLProps,
    getMenuProps
  } = (0, _menu.useMenu)({
    isOpen,
    onCloseRequested,
    // We need to propagate this call back to the KebabMenu's parent in case they want
    // to control the open state externally. Otherwise, useMenu will only know about
    // onOpenRequested from useMenuOpenState, not the parent component.
    onOpenRequested: (0, _react.useCallback)(() => {
      providedOnOpenRequested?.();
      onOpenRequested();
    }, [providedOnOpenRequested, onOpenRequested]),
    targetRef: ref
  });
  const buttonProps = getTargetHTMLProps(rest);
  const menuProps = getMenuProps(restMenuProps);
  const appearance = rest.appearance || (0, _kebabMenuTheme.getButtonAppearance)(themeMode);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.Button, (0, _extends2.default)({
    iconBefore: (0, _kebabMenuTheme.getKebabIcon)({
      themeMode,
      size,
      appearance
    }),
    appearance: (0, _kebabMenuTheme.getButtonAppearance)(themeMode),
    size: size
  }, buttonProps)), /*#__PURE__*/_react.default.createElement(_menu.Menu, menuProps, children));
});
exports.KebabMenu = KebabMenu;
KebabMenu.displayName = "KebabMenu";
//# sourceMappingURL=KebabMenu.js.map